export interface Volume {
  code: string
  name: string
  count: string
  intro: string
  solves: string
  result: string
}

export const volumes: Volume[] = [
  {
    code: '01',
    name: 'Velocidad, Aceleración y Mecánica',
    count: '+12 sesiones prácticas',
    intro:
      'Domina la enseñanza de salidas, aceleración y velocidad máxima. Ejercicios organizados por progresión clara: desde postura básica hasta salida reactiva a máxima intensidad.',
    solves:
      'Atletas que no salen bien, que corren “sentados” o que no entienden la diferencia entre empuje inicial y velocidad máxima.',
    result:
      'Tus velocistas aceleran más rápido y entienden el gesto técnico desde el primer paso.',
  },
  {
    code: '02',
    name: 'Vallas y Relevos',
    count: '+11 sesiones prácticas',
    intro:
      'Protocolos para enseñar ritmo de tres pasos, ataque agresivo al obstáculo y entrega de testimonio bajo presión. Progresiones desde vallas bajas hasta altura competitiva.',
    solves:
      'Atletas que saltan las vallas en vez de pasarlas. Relevos que pierden tiempo en la zona de entrega. Equipos descoordinados.',
    result:
      'Vallistas con ritmo limpio y relevos que se entienden sin mirar atrás.',
  },
  {
    code: '03',
    name: 'Medio Fondo, Fondo y Marcha',
    count: '+13 sesiones prácticas',
    intro:
      'Estrategias para construir base aeróbica, potencia anaeróbica y economía de carrera. Gestión de ritmos, pacing inteligente y técnica de marcha atlética con reglas competitivas.',
    solves:
      'Fondistas que se aburren, que no entienden dónde entrenar según la zona de intensidad o que pierden técnica por fatiga.',
    result:
      'Atletas de fondo con ritmo estable, mejor economía de carrera y capacidad de aguantar potencia al final.',
  },
  {
    code: '04',
    name: 'Saltos',
    count: '+12 sesiones prácticas',
    intro:
      'Longitud, triple, altura y pértiga. Guías paso a paso para carrera de aproximación, batida activa y fase aérea. Progresiones desde fundamentos hasta competencia.',
    solves:
      'Saltadores que no llegan a la tabla con ritmo, que frenan, que saltan en vez de atacar o que no tienen cadencia consistente.',
    result:
      'Tus saltadores dominan la carrera de impulso y ejecutan batidas potentes y consistentes.',
  },
  {
    code: '05',
    name: 'Lanzamientos',
    count: '+9 sesiones prácticas',
    intro:
      'Peso, disco, jabalina y martillo. Técnicas lineales y rotacionales explicadas de forma simple. Transferencia de energía desde los pies hasta el implemento, priorizando siempre la seguridad.',
    solves:
      'Lanzadores que lanzan solo con el brazo, sin transferencia corporal, o que pierden dirección y control.',
    result:
      'Secuencia corporal correcta, transferencia real de potencia y lanzamientos más lejanos.',
  },
  {
    code: '06',
    name: 'Gestión de Grupos Mixtos y Planificación',
    count: '+13 sesiones integradas',
    intro:
      'El cerebro del sistema. Cómo manejar 20+ atletas en una sola pista, organizar macrociclos, hacer tapering (puesta a punto) y competir sin riesgos. Planificación real para entrenadores con grupos grandes.',
    solves:
      'Caos en la pista, grupos desordenados, atletas con sobrecarga o falta de frescura en competencia.',
    result:
      'Control total de tu programa, atletas frescos en competencia y sesiones sin improvisar.',
  },
]
